module.exports = __webpack_public_path__ + "media/images/game/who_can_join/task_kinds-7d39e39f9d805b3a43682e1d4072e58b.png";